import { createSlice } from '@reduxjs/toolkit'
import type { INews } from './INews';

const initialState: {
  news: Record<string, INews>
  active: string | null
} = {
  news: {},
  active: null
}

const news = createSlice({
  name: 'news',
  initialState,
  reducers: {
    setNews(state, { payload }: { payload: INews[] }) {
      const record: Record<string, INews> = {}
      payload.forEach(n => { record[n.id] = n })
      state.news = record
    },
    setActiveNews(state, { payload }: { payload: string | null }) {
      state.active = payload
    },
    changeNewsViewed(state, { payload }: { payload: { id: string, viewed?: boolean } }) {
      const { id, viewed = true } = payload
      const news = state.news[id]
      if (news) {
        news.viewed = viewed
      }
    },
    readAllNews(state) {
      Object.values(state.news).forEach(n => { n.viewed = true })
    }
  }
})

export const {
  setNews,
  setActiveNews,
  changeNewsViewed: _changeNewsViewed,
  readAllNews: _readAllNews,
} = news.actions

export default news.reducer
